import Cookies from 'js-cookie'

const TokenKey = 'treasure-sevice-Token'
const BridgeTokenKey = 'bridge-sevice-Token'
const RefreshKey = 'Refresh-Token'
const KYC_COOKIE_EXPIRES_DAYS = 180
const defaultCookieOptions = {
  sameSite: 'Lax',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:'
}

function setCookie(name, value, options = {}) {
  return Cookies.set(name, value, { ...defaultCookieOptions, ...options })
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return setCookie(TokenKey, token)
}

export function getBridgeToken() {
  return Cookies.get(BridgeTokenKey)
}

export function setBridgeToken(token) {
  return setCookie(BridgeTokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRefreshToken() {
  return Cookies.get(RefreshKey)
}

export function setRefreshToken(token) {
  return setCookie(RefreshKey, token)
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshKey)
}

export function setBusinessKYC(flag) {
  return setCookie("BusinessKYC", flag, { expires: KYC_COOKIE_EXPIRES_DAYS })
}
export function setPersonalKYC(flag) {
  return setCookie("PersonalKYC", flag, { expires: KYC_COOKIE_EXPIRES_DAYS })
}
export function getBusinessKYC() {
  return Cookies.get("BusinessKYC")
}
export function getPersonalKYC() {
  return Cookies.get("PersonalKYC")
}
